import type { RSAAAction } from 'redux-api-middleware';
import { RSAA } from 'redux-api-middleware';
import type { RSAACallAction, RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import { MANAGER_VIEW_APP_PREFIX, apiConfigHelper, locHrefUtil } from '@makemydeal/dr-shared-ui-utils';
import { getDealXgId } from '../selectors/offerRedux';
import type { EmployeeTeam, StateTree, EmployeeSearchParams } from '@makemydeal/dr-dash-types';
import {
    EMPLOYEE_DETAILS_OPEN_SLIDEOUT,
    EMPLOYEE_DETAILS_CLOSE_SLIDEOUT,
    EMPLOYEE_DETAILS_UPDATE_EMPLOYEES,
    EMPLOYEE_DETAILS_START_UPDATE_REQUEST,
    EMPLOYEE_DETAILS_SEND_UPDATE_FAILURE,
    EMPLOYEE_DETAILS_SEND_UPDATE_REQUEST,
    EMPLOYEE_DETAILS_SEND_UPDATE_SUCCESS,
    EMPLOYEE_SEARCH_REQUEST,
    EMPLOYEE_SEARCH_SUCCESS,
    EMPLOYEE_SEARCH_FAILURE
} from '../actionTypes/employeeDetailsActionTypes';

export const openEmployeeDetailsSlideout = () => ({
    type: EMPLOYEE_DETAILS_OPEN_SLIDEOUT
});

export const closeEmployeeDetailsSlideout = () => ({
    type: EMPLOYEE_DETAILS_CLOSE_SLIDEOUT
});

export const updateEmployeeDetails = (employees: EmployeeTeam) => ({
    type: EMPLOYEE_DETAILS_UPDATE_EMPLOYEES,
    payload: { employees }
});

export const startSendEmployeeUpdate = (employees: EmployeeTeam) => ({
    type: EMPLOYEE_DETAILS_START_UPDATE_REQUEST,
    payload: { employees }
});

export const sendEmployeeUpdate = (employees: EmployeeTeam) => (dispatch: (action: any) => void, getState: () => StateTree) => {
    const state = getState();
    const dealXgId = getDealXgId(state);

    const locHref = locHrefUtil.getLocHref();
    const { url: endpoint } = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, '/employees');

    const body = {
        dealXgId,
        employees: Object.values(employees).filter((employee) => employee !== undefined)
    };

    dispatch({
        [RSAA]: {
            endpoint,
            method: 'PUT',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(body),
            types: [
                EMPLOYEE_DETAILS_SEND_UPDATE_REQUEST,
                { type: EMPLOYEE_DETAILS_SEND_UPDATE_SUCCESS, payload: { employees } },
                EMPLOYEE_DETAILS_SEND_UPDATE_FAILURE
            ]
        }
    });
};

/**
 * Search for employees by role and optional filters
 * @param params - Search parameters including coOrgId, role, firstName, lastName, limit
 * @returns RSAA action that triggers API call via redux-api-middleware
 */
export const searchEmployees = (params: EmployeeSearchParams): RSAAAction => {
    const locHref = locHrefUtil.getLocHref();
    const { url: baseUrl } = apiConfigHelper.buildBffApiUrl(
        MANAGER_VIEW_APP_PREFIX,
        locHref,
        `/dealers/${params.commonOrgId}/employees`
    );

    const queryParams = new URLSearchParams();
    if (params.firstName) {
        queryParams.append('firstName', params.firstName);
    }
    if (params.lastName) {
        queryParams.append('lastName', params.lastName);
    }
    if (params.role) {
        queryParams.append('role', params.role);
    }
    if (params.limit) {
        queryParams.append('limit', params.limit.toString());
    }
    const endpoint = `${baseUrl}?${queryParams.toString()}`;
    const request: RSAACallRequest = {
        endpoint,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [EMPLOYEE_SEARCH_REQUEST, EMPLOYEE_SEARCH_SUCCESS, EMPLOYEE_SEARCH_FAILURE]
    };
    return {
        [RSAA]: request
    } as RSAACallAction;
};
